<template lang="pug">
  .release-notes

    h1.subtitle.is-2 Release Notes

    div(v-for="version in versions.slice().reverse()")

      .release-header
        h2.release-name.subtitle.is-4(:class='{"has-text-primary": version.version === currentVersion}') Version {{version.version}}
        .release-date {{version.releaseDate}}
        .release-current.has-text-primary(v-if="version.version === currentVersion") (current)

      p.release-notes {{version.notes}}
      ul(v-if="version.features")
        li(v-for="feature in version.features")
          strong.feature-header {{feature.header}} &nbsp;
          span.feature-detail(v-html="feature.details")

      router-link(:to="{name: 'Welcome'}", v-if="version.version === currentVersion").button.is-primary.intext-back-button
        span.icon
          fa-icon(icon='thermometer-three-quarters')
        span Back to Brewing!

    router-link(:to="{name: 'Welcome'}").button.is-primary.is-large.big-back-button
      span.icon
        fa-icon(icon='thermometer-three-quarters')
      span Back to Brewing!

</template>

<script>
import { getCurrentVersion } from '../version'
import releaseNotes from '../data/releaseNotes.json'

export default {
  name: 'ReleaseNotes',
  props: {
  },
  data () {
    let currentVersion = getCurrentVersion()

    return {
      currentVersion: currentVersion,
      lastSeenVersion: this.$localStorage.get('lastSeenVersion', currentVersion),
      versions: releaseNotes
    }
  }
}
</script>

<style lang="stylus">

.release-notes
  .release-header
    margin 20px 0 5px 0
    padding 0
    display flex
    align-items baseline

  .release-name
    margin 0

  .release-date
    font-style italic
    padding 0 10px

  li
    margin 0 0 0 40px
    list-style disc

  .intext-back-button
    margin 10px 0 30px 0

  .big-back-button
    margin 30px 0 0 0

  .feature-detail
    padding 0

</style>
